import { Link } from 'react-router-dom';
import { novels } from '@/mocks/novels';

export default function LatestArticles() {
  const latest = novels.slice().sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  ).slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最新文章
            </h2>
            <p className="text-sm text-foreground-500 mt-2">深度情感解析与作品导读</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((novel) => (
            <article
              key={novel.id}
              className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 group cursor-pointer"
            >
              <Link to={`/article/${novel.id}`} className="block">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={novel.coverImage}
                    alt={novel.title + ' - 小说导读与深度解析'}
                    title={novel.title + ' - 情感叙事解析'}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center flex-wrap gap-2 mb-3">
                    <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-800 rounded-full whitespace-nowrap">
                      {novel.category}
                    </span>
                    {novel.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2 py-0.5 bg-background-200/70 text-foreground-600 rounded-full whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {novel.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-3 mb-4 leading-relaxed">
                    {novel.description}
                  </p>
                  <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-foreground-500">{novel.author}</span>
                      <span className="text-xs text-foreground-300">·</span>
                      <span className="text-xs text-foreground-400">{novel.publishDate}</span>
                    </div>
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-eye-line text-xs"></i>
                      {(novel.views / 10000).toFixed(1)}万
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}